import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function InquiryThanksPage() {
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-6767">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="max-w-md w-full bg-surface border border-border rounded-2xl p-8 text-center" data-id="element-6768">
        <div className="w-16 h-16 rounded-full bg-green-500/20 text-green-500 flex items-center justify-center mx-auto mb-6" data-id="element-6769">
          <CheckCircle2 className="w-8 h-8" data-id="element-6770" />
        </div>
        <h1 className="text-2xl font-bold mb-2" data-id="element-6771">Inquiry Submitted</h1>
        <p className="text-textMuted mb-8" data-id="element-6772">
          Thanks for reaching out. Your booking inquiry has been sent
          successfully. The team will review your details and get back to you
          soon.
        </p>
        <div className="space-y-4" data-id="element-6773">
          <button className="w-full py-2 bg-surface border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors" data-id="element-6774">
            Submit Another Inquiry
          </button>
          <div className="pt-4 border-t border-border" data-id="element-6775">
            <p className="text-xs text-textMuted" data-id="element-6776">
              Want to manage your own bookings like this? <br data-id="element-6777" />
              <Link to="/" className="text-primary hover:underline mt-1 inline-block" data-id="element-6778">
                Learn more about Booker
              </Link>
            </p>
          </div>
        </div>
      </motion.div>
    </div>;
}